export default __webpack_public_path__ + "static/media/iyana-ipaja-terminal.2ba52b44.png";